// extracted by mini-css-extract-plugin
export default {"noVideoContainer":"NoVideos_noVideoContainer__TZph2","noVideoText":"NoVideos_noVideoText__m2+f4"};